<template>
  <div class="c-controls-resources-nav">
    <div class="inner">
      <div class="padding">
        <h1 v-if="heading && heading.value && heading.value.length > 0">
          {{ heading.value }}
        </h1>
        <h2 v-if="subheading && subheading.value && subheading.value.length > 0">
          {{ subheading.value }}
        </h2>

        <div class="filters">
          <div class="category">
            <span class="filters__label">Select Category</span>
            <div ref="select1" class="custom-select" @blur="openCategory = false">
              <div
                class="selected"
                :class="{ open: openCategory }"
                @click="
                  openCategory = !openCategory;
                  openFilter = false;
                "
              >
                {{ selectedCategoryLabel }}
              </div>
              <div class="items" :class="{ selectHide: !openCategory }">
                <div
                  class="item"
                  v-for="category of categories"
                  :key="category.name"
                  :class="{ active: isCategorySelected(category) }"
                  @click="
                    setCategory(category.id);
                    selected = category.fields.name?.value;
                    openCategory = false;
                  "
                >
                  {{ category.fields.name?.value }}
                </div>
              </div>
            </div>
          </div>
          <div class="versions">
            <span class="filters__label">Filter by Version</span>
            <div ref="select2" class="custom-select" @blur="openFilter = false">
              <div
                class="selected"
                :class="{ open: openFilter }"
                @click="
                  openFilter = !openFilter;
                  openCategory = false;
                "
              >
                {{ selectedVersionsLabel }}
              </div>
              <div class="items" :class="{ selectHide: !openFilter }">
                <div
                  class="item"
                  v-for="version in versions"
                  :key="version.name"
                  :class="{ active: isVersionSelected(version) }"
                >
                  <div class="checkbox-container">
                    <input
                      type="checkbox"
                      name="versions"
                      :id="`version-${version.id}`"
                      :value="version.id"
                      :checked="isVersionSelected(version)"
                      @change="toggleVersion($event, version.name)"
                    />
                    <label class="c-checkbox" :for="`version-${version.id}`">
                      {{ version.fields.name?.value }}</label
                    >
                  </div>
                </div>
                <span class="clearFilter" @click="clearVersion">Clear Filters</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Sorts an array of versions numbers so they sort the decimal values properly
//   const versions = ["v8.2", "v8.11", "v8", "v7.1"];
//   versions.sort(compareVersions);
//   console.log(versions); // Output: ["v7.1", "v8", "v8.2", "v8.11"]
function compareVersions(a, b) {
  const versionA = a.slice(1).split('.').map(Number);
  const versionB = b.slice(1).split('.').map(Number);

  for (let i = 0; i < Math.max(versionA.length, versionB.length); i++) {
    const numA = versionA[i] || 0;
    const numB = versionB[i] || 0;

    if (numA > numB) return 1;
    if (numA < numB) return -1;
  }

  return 0;
}
export default {
  name: 'CIS-Controls-Resources-Nav',
  emits: ['setCategory', 'toggleVersion', 'clearVersion'],
  props: {
    heading: {
      type: Object,
      default: () => ({})
    },
    subheading: {
      type: Object,
      default: () => ({})
    },
    categories: {
      type: Array,
      default: () => []
    },
    versions: {
      type: Array,
      default: () => []
    },
    queryData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      openFilter: false,
      openCategory: false
    };
  },
  mounted() {
    if (document) {
      document.addEventListener('click', this.handleClickOutside);
    }
  },
  computed: {
    selectedCategoryLabel() {
      if (!this.categories) {
        return '';
      }

      const selectedCategory = this.categories.find((c) => {
        return this.queryData.categoryId === c.id;
      });

      return selectedCategory?.fields?.name?.value;
    },
    selectedVersionsLabel() {
      if (!this.versions) {
        return '';
      }

      if (
        this.queryData?.versionIds?.length === 0 ||
        this.queryData?.versionIds?.length === this.versions?.length
      ) {
        return 'All Versions';
      }
      const selectedVersions = this.versions.filter((v) => {
        return this.queryData.versionIds.indexOf(v.id) >= 0;
      });

      return selectedVersions
        .map((v) => v.fields.slug.value)
        .sort(compareVersions)
        .reverse()
        .join(', ');
    }
  },
  methods: {
    setCategory(category) {
      const categoryId = category;
      this.$emit('setCategory', categoryId);
    },
    isCategorySelected(category) {
      return category.id === this.queryData.categoryId;
    },
    isVersionSelected(version) {
      return this.queryData.versionIds.some((v) => v === version.id);
    },
    toggleVersion(e) {
      e.preventDefault();
      const versionId = e.target?.value;
      this.$emit('toggleVersion', versionId);
    },
    clearVersion(e) {
      e.preventDefault();
      this.$emit('clearVersion');
    },
    handleClickOutside(event) {
      if (
        !this.$refs?.select1?.contains(event.target) &&
        !this.$refs?.select2?.contains(event.target)
      ) {
        if (this.openCategory && !this.openCategory === false) this.openCategory = false;
        if (this.openFilter && !this.openFilter === false) this.openFilter = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '~@/assets/scss/components/checkbox.scss';

.c-controls-resources-nav {
  @include padding-y(2.5rem, 4rem);
  color: $white;
  background: linear-gradient(
    169deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 59, 92, 1) 20%,
    rgba(0, 134, 191, 1) 100%
  );

  @include tablet-up {
    @include padding-y(4rem);
  }

  .inner {
    @include exlarge-desktop-up {
      @include padding-x-thin;
    }

    .padding {
      @include padding-x(2rem);

      @include tablet-up {
        @include padding-x(4rem);
      }

      @include desktop-up {
        @include padding-x(7rem);
      }
    }

    h1 {
      -webkit-text-fill-color: $white;
      text-transform: uppercase;
      margin: 0 0 1.6rem 0;
      @include font-styles('Arial', 1.8rem, 600, normal, normal, 0.1rem, $white);
    }

    h2,
    p,
    span {
      color: $white;
    }

    h2 {
      -webkit-text-fill-color: $white;
      font-size: 2.4rem;
      line-height: 3rem;
      margin-bottom: 3rem;

      @include tablet-up {
        font-size: 3.6rem;
        line-height: 4.2rem;
        margin-bottom: 4rem;
      }

      &::before {
        display: none;
      }
    }

    .filters {
      @include tablet-up {
        display: flex;
      }

      &__label {
        display: block;
        margin-bottom: 1rem;
        text-transform: uppercase;
        @include font-styles('Arial', 1.4rem, 600, normal, normal, 0.1rem, $white);
      }

      .category {
        width: 100%;
        margin-bottom: 5rem;

        @include tablet-up {
          width: auto;
          min-width: 40rem;
          margin-right: 8rem;
          margin-bottom: 0;
        }
      }

      .versions {
        width: 100%;
        @include tablet-up {
          width: auto;
          min-width: 20rem;
        }
      }

      .custom-select {
        position: relative;
        width: 100%;

        outline: none;

        .selected {
          border-bottom: 0.3rem solid $orange;
          padding: 1.5rem 3rem 1.5rem 0;
          cursor: pointer;
          user-select: none;
          position: relative;
          @include font-styles('Arial', 2rem, 300, normal, 3rem, 0, $white);

          &:after {
            content: '';
            display: inline-block;
            position: absolute;
            top: 40%;
            right: 0.3rem;
            height: 1.2rem;
            transform: rotate(135deg) translate(0);
            transform-origin: center;
            width: 1.2rem;
            border-top: solid 0.2rem $white;
            border-right: solid 0.2rem $white;
            transition: all 0.5s ease;
          }

          &.open {
            &:after {
              transform: rotate(-45deg) translate(-0.5rem, 0.5rem);
            }
          }
        }

        .items {
          color: #fff;
          overflow: hidden;
          position: absolute;
          background-color: $white;
          left: 0;
          right: 0;
          z-index: 1;
          border-radius: 0 0 0.5rem 0.5rem;
          box-shadow: 0.2rem 0.4rem 1.2rem 0 rgba(0, 0, 0, 0.25);

          .item {
            color: $gray;
            margin: 2.5rem 1.8rem;
            cursor: pointer;
            user-select: none;

            .c-checkbox {
              input {
                position: relative;
                top: 0.2rem;
                border: solid 0.2rem $blue;

                &:before {
                  width: 1.6rem;
                  height: 1.6rem;
                }
              }
            }

            [type='checkbox']:not(:checked) + label,
            [type='checkbox']:checked + label {
              display: initial;
              max-width: none;
              position: static;
              margin-top: 0.5rem;
              margin-right: 0.5rem;
              font-size: 2rem;
              font-weight: 300;
            }

            [type='checkbox'] + label[data-v-23901f43]:before {
              @include phone-only {
                top: 0;
              }
            }

            [type='checkbox']:checked + label[data-v-23901f43]:after {
              @include phone-only {
                top: 0.4rem;
              }
            }

            &.active {
              font-weight: 500;

              [type='checkbox']:not(:checked) + label,
              [type='checkbox']:checked + label {
                font-weight: 500;
              }
            }
          }
        }

        .selectHide {
          display: none;
        }

        .clearFilter {
          display: inline-block;
          margin: 1rem 2rem 2rem;
          cursor: pointer;
          @include font-styles('Arial', 1.6rem, 500, normal, normal, 0.1rem, $gray);

          &:before {
            position: relative;
            top: 0.2rem;
            width: 1.4rem;
            height: 1.4rem;
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1L13 13" stroke="%23303E48" stroke-width="2"/><path d="M1 13L13 1" stroke="%23303E48" stroke-width="2"/></svg>');
            margin-right: 1rem;
          }
        }
      }
    }
  }
}
</style>
